import useContentIcons from "@/hooks/useContentIcons";
import {useCarouselStore, type TCarouselMedia} from "@/store/carousel";
import {memo, useMemo, type FC} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router";

const CarouselHeader: FC<{
  currentMediaIndex: number;
  mediaLength: number;
  currentMedia: TCarouselMedia;
}> = ({currentMediaIndex, currentMedia, mediaLength}) => {
  const {t} = useTranslation();
  const content = useContentIcons(currentMedia.instagram_media?.media_product_type!);
  const carouselCampaign = useCarouselStore(state => state.campaign);
  const campaign = useMemo(() => currentMedia.campaign ?? carouselCampaign, [currentMedia, carouselCampaign]);
  const variant = useCarouselStore(state => state.variant);

  if (variant === "assets" && !!currentMedia.assetName) {
    return (
      <div className="mb-4 ml-3 flex items-center text-base font-normal text-white">
        <span className="inline-block max-w-[calc(100%-64px)] truncate">{currentMedia.assetName}&nbsp;</span>
        <span>{" • " + (currentMediaIndex + 1) + "/" + mediaLength}</span>
      </div>
    );
  }

  if (variant === "social_feed") {
    return (
      <div className="mb-4 flex items-center">
        <img src={currentMedia.user?.picture!} className="size-7 shrink-0 rounded-full" />
        <Link
          to={`/influencer/${currentMedia.user?.influencer_id}/`}
          target="_blank"
          className="ml-3 text-left text-base font-normal text-white no-underline hover:text-white/90">
          {currentMedia.user?.first_name}
        </Link>
      </div>
    );
  }

  return (
    <div className="mb-4 flex items-center">
      <img src={currentMedia.user?.picture!} className="size-7 shrink-0 rounded-full" />
      <div className="ml-3 flex items-center gap-1 text-white">
        <span className="text-left text-base font-normal text-white">
          <Link
            to={`/influencer/${currentMedia.user?.influencer_id}/`}
            target="_blank"
            className="text-white no-underline hover:text-white/90">
            {currentMedia.user?.first_name}
          </Link>{" "}
          •{" "}
          {!!campaign && (
            <Link
              to={`/campaign/${campaign.id}/`}
              target="_blank"
              className="text-white no-underline hover:text-white/90">
              {campaign.title} •
            </Link>
          )}{" "}
          {currentMediaIndex + 1}/{mediaLength} •
        </span>
        <div className="flex items-center gap-2">
          <content.Icon className="size-4 shrink-0" />
          <span className="text-sm">{t(content.translationKey)}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(CarouselHeader);
